import { c as _c } from "react/compiler-runtime";
import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { bulkActionResultsSelector, numberOfUpdatingItemsSelector } from "@store/table/table-selector";
import { useAppSelector } from "@store/store-helper";
import { nounPluralize } from "@utils/data-display";
import { UtilsTypes } from "@stellar/utils";

/** Determines the content of bulk dialog and bulk success dialog for changing project status */
export function useChangeProjectStatusBulkDialogContent(projectStatus) {
  const $ = _c(20);
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    numberOfSuccess,
    numberOfErrors
  } = useAppSelector(bulkActionResultsSelector);
  const t0 = `${projectStatus === UtilsTypes.ProjectArchivingState.archived ? "Unarchive" : "Archive"} these projects?`;
  const t1 = projectStatus === UtilsTypes.ProjectArchivingState.archived ? "Unarchiving these projects will make them accessible to users with appropriate permissions" : "Archiving these projects will exclude them from some users, only members with permissions can access them";
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      title: t0,
      description: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `Couldn't ${projectStatus === UtilsTypes.ProjectArchivingState.archived ? "unarchive" : "archive"} ${numberOfErrors} of ${numberOfUpdatingItems} projects`;
  let t4;
  if ($[3] !== t3) {
    t4 = {
      title: t3,
      description: "The status of these projects couldn't be changed, check the details and try again."
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = projectStatus === UtilsTypes.ProjectArchivingState.archived ? "unarchive" : "archive";
  let t6;
  if ($[5] !== t2 || $[6] !== t4 || $[7] !== t5) {
    t6 = {
      initial: t2,
      failed: t4,
      confirmButtonText: t5,
      entityType: "project"
    };
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const bulkDialogContent = useGetBulkDialogContent(t6);
  let t7;
  if ($[9] !== numberOfSuccess) {
    t7 = nounPluralize({
      counter: numberOfSuccess,
      word: "project"
    });
    $[9] = numberOfSuccess;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `${t7} archived`;
  let t9;
  if ($[11] !== t8) {
    t9 = {
      title: t8,
      description: "All selected projects have been archived and you can unarchive them at any time"
    };
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let successDialogContent = t9;
  if (projectStatus === UtilsTypes.ProjectArchivingState.archived) {
    let t10;
    if ($[13] !== numberOfSuccess) {
      t10 = nounPluralize({
        counter: numberOfSuccess,
        word: "project"
      });
      $[13] = numberOfSuccess;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    const t11 = `${t10} unarchived`;
    let t12;
    if ($[15] !== t11) {
      t12 = {
        title: t11,
        description: "All selected projects have been unarchived and you can archive them at any time"
      };
      $[15] = t11;
      $[16] = t12;
    } else {
      t12 = $[16];
    }
    successDialogContent = t12;
  }
  let t10;
  if ($[17] !== bulkDialogContent || $[18] !== successDialogContent) {
    t10 = {
      bulkDialogContent,
      successDialogContent
    };
    $[17] = bulkDialogContent;
    $[18] = successDialogContent;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}